/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { useRedirectPath } from '../../Hooks/UseRedirectPath/UseRedirectPath.hook';
import { getAuthService } from '../../Services/auth';

/**
 * This redirects the app to auth0 login for SSO purposes.
 * Once successfully signed in on auth0 side, will redirect back to /authorize with authorization code.
 */
export const DxpLoginRedirect = (): JSX.Element => {
  const from = useRedirectPath();

  // Special case for Signup screen
  let state = from;
  if (from.indexOf(`signup`) !== -1) {
    state = '/';
  }

  const authorizeDto = {
    audience: `https://dxp.squiz.cloud`,
    redirectUri: window.location.origin,
    responseType: `code`,
    scope: `openid profile email address offline_access sxc:backend`,
    state,
  };

  // Auth service
  const authService = getAuthService();
  authService.authorize(authorizeDto);

  return <></>;
};
